/**
 * Story Rules API (#856). A fence, not a voice.
 * Add / edit / turn off / scope. Each rule is its own sentence.
 */
import { api } from './client';

const unwrap = (res) => (res?.data?.data ?? res?.data ?? res);

export async function listStoryRules(storyId, { signal } = {}) {
  return unwrap(await api.get(
    `/stories/${storyId}/story-rules`,
    signal ? { signal } : undefined,
  ));
}

export async function listStoryRuleScopes(storyId, { signal } = {}) {
  return unwrap(await api.get(
    `/stories/${storyId}/story-rules/scopes`,
    signal ? { signal } : undefined,
  ));
}

export async function listApplyingStoryRules(storyId, { sceneId, personId } = {}) {
  const params = new URLSearchParams();
  if (sceneId) params.set('scene_id', sceneId);
  if (personId) params.set('person_id', personId);
  const q = params.toString() ? `?${params}` : '';
  return unwrap(await api.get(`/stories/${storyId}/story-rules/applying${q}`));
}

export async function addStoryRule(storyId, body) {
  return unwrap(await api.post(`/stories/${storyId}/story-rules`, {
    sentence: body.sentence,
    scope_kind: body.scopeKind || body.scope_kind || 'book',
    person_entity_id: body.personEntityId || body.person_entity_id || null,
    scene_section_id: body.sceneSectionId || body.scene_section_id || null,
    enabled: body.enabled !== false,
  }));
}

export async function updateStoryRule(storyId, ruleId, body) {
  return unwrap(await api.patch(`/stories/${storyId}/story-rules/${ruleId}`, {
    sentence: body.sentence,
    scope_kind: body.scopeKind ?? body.scope_kind,
    person_entity_id: body.personEntityId ?? body.person_entity_id,
    scene_section_id: body.sceneSectionId ?? body.scene_section_id,
  }));
}

export async function turnOffStoryRule(storyId, ruleId) {
  return unwrap(await api.post(`/stories/${storyId}/story-rules/${ruleId}/turn-off`));
}

export async function turnOnStoryRule(storyId, ruleId) {
  return unwrap(await api.post(`/stories/${storyId}/story-rules/${ruleId}/turn-on`));
}

export const storyRulesApi = {
  list: listStoryRules,
  scopes: listStoryRuleScopes,
  applying: listApplyingStoryRules,
  add: addStoryRule,
  update: updateStoryRule,
  turnOff: turnOffStoryRule,
  turnOn: turnOnStoryRule,
};
